import { PaletteOptions } from "@mui/material";
import { steelBlue } from "ds/colors/steelBlue";
import { paletteProviderSearchCore } from "./shared";

// PRIMARY
export const WESER_EMS_PRIMARY_DARK = steelBlue[800];
export const WESER_EMS_PRIMARY_MAIN = steelBlue[600];
export const WESER_EMS_PRIMARY_LIGHT = steelBlue[200];

export const paletteProviderSearchWeserEms: PaletteOptions = {
  ...paletteProviderSearchCore,
  primary: {
    dark: WESER_EMS_PRIMARY_DARK,
    light: WESER_EMS_PRIMARY_LIGHT,
    main: WESER_EMS_PRIMARY_MAIN,
  },
} as const;
